import { render, staticRenderFns } from "./myCollectionCourseList.vue?vue&type=template&id=21e3f11e"
import script from "./myCollectionCourseList.vue?vue&type=script&lang=js"
export * from "./myCollectionCourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports